module.exports = __webpack_public_path__ + "08da5f23deedc4ad93bc48427b594f12.png";